import { Injectable, inject, isDevMode } from '@angular/core';
import { Observable, fromEvent, partition, merge, of, tap } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';
import { BrowserContext } from './browser-context.service';

@Injectable({
  providedIn: 'root',
})
export class VisibilityService {
  private readonly ctx = inject(BrowserContext);

  public readonly visibility$: Observable<'visible' | 'hidden'>;
  public readonly pageVisible$: Observable<boolean>;
  public readonly pageHidden$: Observable<boolean>;

  constructor() {
    if (this.ctx.isBrowser) {
      this.visibility$ = merge(
        of(this.ctx.document.visibilityState),
        fromEvent(this.ctx.document, 'visibilitychange').pipe(map(() => this.ctx.document.visibilityState))
      ).pipe(
        distinctUntilChanged(),
        tap(value => isDevMode() && console.log('RX Visible:', value)),
        shareReplay(1)
      );
    } else {
      this.visibility$ = of('visible');
    }

    [this.pageVisible$, this.pageHidden$] = partition(this.visibility$.pipe(map(value => value === 'visible')), v => v);
  }
}
